import type { ReactNode } from 'react'
import { PromptTemplateTablePanel } from '@/components/prompt-templates/prompt-template-table-panel.molecule'
import { usePromptTemplateTable } from '@/components/prompt-templates/use-prompt-template-table.hook'

interface AgencyFormTemplatesTabProps {
  agencySlug?: string
  isDisabled?: boolean
}

/**
 * Tab content for managing prompt templates within an agency form.
 */
export const AgencyFormTemplatesTab = ({
  agencySlug,
  isDisabled: _isDisabled = false,
}: AgencyFormTemplatesTabProps): ReactNode => {
  const tableState = usePromptTemplateTable({ agencySlug })

  return (
    <div className="agency-form-templates-tab space-y-4">
      <div className="space-y-1 pt-4">
        <p className="text-sm text-muted-foreground">
          Manage prompt templates specific to this agency. These templates will be available when
          chatting with this agency.
        </p>
      </div>
      <PromptTemplateTablePanel {...tableState} />
    </div>
  )
}

AgencyFormTemplatesTab.displayName = 'AgencyFormTemplatesTab'
